import { Page } from '../../../../../components/page/page';
import { HasAccess } from '../../../../../features/has-access/has-access.tsx';
import { CheckInCheckOutCards } from './check-in-check-out-cards/check-in-check-out-cards.tsx';
import { CheckInCheckOutControls } from './check-in-check-out-controls/check-in-check-out-controls.tsx';
import { CheckInCheckOutDeleteModal } from './check-in-check-out-delete-modal/check-in-check-out-delete-modal.tsx';
import { CheckInCheckOutEditModal } from './check-in-check-out-edit-modal/check-in-check-out-edit-modal.tsx';
import { CheckInCheckOutHistoryModal } from './check-in-check-out-history-modal/check-in-check-out-history-modal.tsx';
import { CheckInCheckOutListModal } from './check-in-check-out-list-modal/check-in-check-out-list-modal.tsx';
import { CheckInCheckOutTable } from './check-in-check-out-table/check-in-check-out-table.tsx';
import s from './check-in-check-out.module.css';
import { useCheckInCheckOut } from './use-check-in-check-out';

export const CheckInCheckOut = () => {
  const {
    t,
    handleExportClick,
    employees,
    checkinHistoryModal,
    editCheckInCheckOutModal,
    viewStyle,
    nestedCheckinsModal,
    handleEnd,
  } = useCheckInCheckOut();

  return (
    <Page className={s.page}>
      <CheckInCheckOutDeleteModal />

      {nestedCheckinsModal.isOpen && (
        <CheckInCheckOutListModal onClose={() => nestedCheckinsModal.handleCloseModal()} />
      )}

      <HasAccess service="staff" permissions={['write']}>
        {checkinHistoryModal.isOpen && (
          <CheckInCheckOutEditModal onClose={() => checkinHistoryModal.handleCloseModal(['id'])} />
        )}
      </HasAccess>

      {editCheckInCheckOutModal.isOpen && (
        <CheckInCheckOutHistoryModal
          onClose={() => editCheckInCheckOutModal.handleCloseModal()}
          employees={employees}
        />
      )}

      <div className={s.header}>
        <h2 className={s.title}>{t('Приход/Уход')}</h2>

        <CheckInCheckOutControls onExportClick={handleExportClick} />
      </div>
      {viewStyle === 'table' ? (
        <CheckInCheckOutTable />
      ) : (
        <CheckInCheckOutCards onEnd={handleEnd} />
      )}
    </Page>
  );
};
